import queryString from "query-string";
import * as appConstants from "../config/constants";

export var FRAME_NAME = "authframe";

export var SIGNIN = "SIGNIN";

export var REGISTER1 = "REGISTER1";
export var REGISTER2 = "REGISTER2";
export var REGISTER3 = "REGISTER3";

export var FORGOTPASSWORD1 = "FORGOTPASSWORD1";
export var FORGOTPASSWORD2 = "FORGOTPASSWORD2";
export var FORGOTPASSWORD3 = "FORGOTPASSWORD3";
export var FORGOTPASSWORD4 = "FORGOTPASSWORD4";

export var CLIENT_ID = void 0;
switch (process.env.ENV) {
  case "production":
    CLIENT_ID = "platform-site-prod";
    break;
  default:
    // staging and development use the same client id
    CLIENT_ID = "platform-site";
}

// Build auth URL as query string
var authObj = {
  client_id: CLIENT_ID,
  redirect_uri: encodeURI(appConstants.FRONTEND_ROOT + "/authorize"),
  scope: "read write",
  response_type: "token",
  state: Date.now()
};

export var AUTH_URL = appConstants.BACKEND_ROOT + "/o/authorize/?" + queryString.stringify(authObj);

export var LOGOUT_URL = appConstants.BACKEND_ROOT + "/logout/";

export var INDUSTRIES = ["Aerospace / Defense", "Agency", "Agriculture", "Architecture / Engineering / Construction", "Banking / Financial Services / Insurance", "Education", "Energy / Environment / Utilities", "Government", "Healthcare / Pharmaceuticals", "Hospitality", "Manufacturing", "Media / Entertainment", "Not For Profit", "Other", "Professional Services", "Retail / Consumer", "Technology / Telecommunications"];


// WEBPACK FOOTER //
// ./src/constants/authDrawer.js